import {configureStore} from '@reduxjs/toolkit';
import {createLogger} from 'redux-logger';
import appStateReducer from './reducers/appstate';
import alertModalStateReducer from './reducers/alertModalState';
import manageEmployeeStateReducer from './reducers/manageEmployeState';
import teamAssignmentStateReducer from './reducers/teamAssignmentState';
import practiceState from './reducers/practiceState';
import departmentState from './reducers/departmentState';
import periodState from './reducers/periodState';

const reduxLogger = createLogger({
  collapsed: true,
  duration: true,
  logErrors: true,
  diff: true,
});

const store = configureStore({
  reducer: {
    periodState: periodState,
    departmentState: departmentState,
    practiceState: practiceState,
    appState: appStateReducer,
    alertModalState: alertModalStateReducer,
    manageEmployeeState: manageEmployeeStateReducer,
    teamAssignmentState: teamAssignmentStateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(reduxLogger),
});

export const getDispatch = () => {
  return store.dispatch;
};

export default store;
